module.exports = __webpack_public_path__ + "media/show-answer.4d2cf577.mp3";